<template>
    <v-row>
        <v-col>
            <p>
                Unused items purchased from {{ brandDomainName }} may be returned for a refund within 30 days of the original purchase date. We offer free shipping on returns.
            </p>
            <p>
                <strong>Return authorization is required.</strong> To return an item, start a return online to receive a Return Merchandise Authorization (RMA) and a prepaid return shipping label. Items shipped back to us without an RMA can't be matched to your order and may not be eligible for a credit or refund.
            </p>
            <p class="text-center">
                <v-btn color="primary" :to="{ path: '/return' }">
                    Start a Return
                </v-btn>
            </p>
            <p>
                If you're logged in, you can also start a return from your <NuxtLink to="/account/orders">Order History</NuxtLink>.
            </p>
            <p>
                If you have any trouble starting a return, please email us at <a href="mailto:returns@stringking.com">returns@stringking.com</a>.
            </p>
            <p class="text-center">
                <v-btn :to="{ path: '/support/contact', query: { to: 'returns', subject: 'Product Return' } }">
                    Contact Returns
                </v-btn>
            </p>
            <p>
                Once returned items are received and verified by our returns department, we will issue a refund to
                the method of payment used to place the original order. Once issued, refunds take 5–10 days to
                appear on your statement. To check the status of your return, contact
                <a href="mailto:returns@stringking.com">returns@stringking.com</a>
                .
            </p>
        </v-col>
    </v-row>
    <v-row>
        <v-col>
            <h2 class="page-title">Policy Exceptions</h2>
        </v-col>
    </v-row>
    <v-row>
        <v-col>
            <p>
                We are unable to refund shipping charges unless delivery was delayed.
            </p>
            <p>
                We do not offer refunds on used items or items purchased through our retail partners. If would like to return a purchase made through one of our retail partners, please contact them for information on their return policy.
            </p>
            <p>
                If your item is damaged or defective, you may qualify for a free replacement. Please submit a <NuxtLink to="/support/warranty">Warranty Claim</NuxtLink> , or contact us at <a href="mailto:returns@stringking.com">returns@stringking.com</a> for additional information.
            </p>
            <p class="text-center">
                <v-btn to="/support/warranty" nuxt>Submit a Warranty Claim</v-btn>
            </p>
        </v-col>
    </v-row>
</template>

<script lang="ts" setup>
    const props = defineProps<{
        brandDomainName: string;
    }>();
</script>

<style lang="scss"></style>
